<template>
  <div
    class="solutionsContainer"
    :style="{ height: isQuickStart ? 'calc(100vh - 48px)' : '100vh' }"
    :class="{ 'mt-12': isQuickStart }"
  >
    <v-row
      class="solutionsContent justify-space-between"
      :class="{ mobileSolutionsContent: isMobileSized }"
    >
      <v-col
        :cols="isMobileSized ? 12 : 5"
        class="d-flex px-10"
        style="position:relative;"
        :class="isMobileSized ? 'mt-16' : ''"
        :style="isMobileSized ? '' : 'height:100%;'"
      >
        <div :class="{ mobileDisplayContainer: isMobileSized }">
          <StepIcons :currentView="'solutions'" :isMobileSized="isMobileSized" />
          <v-row no-gutters align="center" :style="isMobileSized ? '' : 'height:54vh'">
            <div>
              <div
                class="text-h4 font-weight-bold solutionsTitle"
                :class="{ mobileTitle: isMobileSized }"
              >
                Solutions That Work!
              </div>
              <p
                class="largeDescriptionText"
                :class="isMobileSized ? 'mobileDescriptionText mt-2' : 'mt-6'"
              >
                Based on your business type and advertising goals, one of these solutions will work
                perfectly for you. Pick the one you like most, then hit 'Next' to start customizing
                your ads.
              </p>
            </div>
          </v-row>
        </div>
      </v-col>
      <v-col
        class="d-flex align-center justify-center pl-7 pr-10"
        style="background-color: rgb(94, 0, 235);"
        :style="isMobileSized ? 'padding-bottom: 166px;' : 'height: 100%'"
      >
        <SolutionSelector
          :solutionThumbnails="solutionThumbnails"
          :isLoadingThumbnails="isLoadingThumbnails"
          :modalText="''"
          :isModal="false"
          :vertical="vertical"
          :isShopifyUser="isShopifyUser"
          :isQuickStart="isQuickStart"
          :mode="mode"
          :currentSolutionId="selectedSolutionId"
          :isMobileSized="isMobileSized"
          @changeMode="$emit('changeMode', $event)"
          @selectSolution="selectSolution"
          @selectSolutionAndContinue="selectSolutionAndContinue"
        />
        <div class="backNextButtonDisplay" :class="{ mobileBackNextButtonDisplay: isMobileSized }">
          <v-btn
            class="mr-3"
            dark
            color="grey lighten-1"
            @click="
              guibus_publish('dispatch:beacon', {
                eventId: `welcome-solutions_slide_back_button-click${
                  isMobileSized ? '-mobile' : ''
                }`,
              })
              $emit('stepBack', 'survey')
            "
            >Back</v-btn
          >
          <v-btn
            dark
            color="primary"
            @click="
              guibus_publish('dispatch:beacon', {
                eventId: `welcome-solutions_slide_next_button-click${
                  isMobileSized ? '-mobile' : ''
                }`,
              })
              $emit('changeStep', { step: 'ads', solutionId: selectedSolutionId })
            "
            >Next</v-btn
          >
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import StepIcons from '../units/StepIcons.vue'
import SolutionSelector from '../units/SolutionSelector.vue'
import * as STATIC_SOLUTION_OPTIONS from '../configs/staticSolutionOptions'
import * as DYNAMIC_SOLUTION_OPTIONS from '../configs/dynamicSolutionOptions'
import EnvService from 'env-service'
import CampaignSolutionInterfaceFactoryNoAuth from 'bs-interface-campaign-solution/bs-interface-campaign-solution-prelogin'

export default {
  components: {
    StepIcons,
    SolutionSelector,
  },
  props: {
    vertical: {
      type: String,
      default: 'retail',
    },
    subVertical: {
      type: String,
      default: 'Legal',
    },
    useCase: {
      type: String,
      default: undefined,
    },
    mode: {
      type: String,
      default: 'static',
    },
    solutionId: {
      type: Number,
      default: undefined,
    },
    isShopifyUser: {
      type: Boolean,
      default: false,
    },
    isQuickStart: {
      type: Boolean,
      default: false,
    },
    isMobileSized: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      solutionThumbnails: [],
      allSolutionOptions:
        this.mode === 'dynamic'
          ? DYNAMIC_SOLUTION_OPTIONS.default[this.isQuickStart ? 'quickstart' : 'freemium']
          : STATIC_SOLUTION_OPTIONS.default[this.isQuickStart ? 'quickstart' : 'freemium'],
      solutionOptionsForVertical: [],
      selectedSolutionId: this.solutionId,
    }
  },
  beforeMount() {
    this.fetchSolutions()
  },
  methods: {
    async fetchSolutions() {
      this.isLoadingThumbnails = true
      this.solutionOptionsForVertical = this.isProductionEnv
        ? this.allSolutionOptions.production[this.vertical][
            this.vertical === 'service' ? this.subVertical : this.useCase
          ]
        : this.allSolutionOptions.staging[this.vertical][
            this.vertical === 'service' ? this.subVertical : this.useCase
          ]
      for (let i = 0; i < this.solutionOptionsForVertical.length; i++) {
        if (this.isQuickStart) {
          await this.CampaignSolutionInterface.getAllThumbnailsForSolution(
            this.solutionOptionsForVertical[i],
            r => {
              this.addThumbnails(r, i)
            }
          )
        } else {
          await this.CampaignSolutionInterfaceNoAuth.getAllThumbnailsForSolution(
            this.solutionOptionsForVertical[i]
          ).then(r => {
            this.addThumbnails(r, i)
          })
        }
      }
      if (!this.solutionId) {
        this.selectedSolutionId = this.solutionOptionsForVertical[0]
      }
    },
    addThumbnails(response, index) {
      this.solutionThumbnails.push({
        campaignSolutionId: this.solutionOptionsForVertical[index],
        ...response['300x250'],
      })
      if (index === this.solutionOptionsForVertical.length - 1) {
        this.isLoadingThumbnails = false
      }
    },
    selectSolution(solutionId) {
      this.selectedSolutionId = solutionId
    },
    selectSolutionAndContinue(solutionId) {
      this.selectedSolutionId = solutionId
      this.$emit('changeStep', { step: 'ads', solutionId: this.selectedSolutionId })
    },
  },
  computed: {
    CampaignSolutionInterface() {
      return window.adacado.bscs
        ? window.adacado.bscs.CampaignSolutionInterfaceFactory()
        : undefined
    },
    CampaignSolutionInterfaceNoAuth() {
      return CampaignSolutionInterfaceFactoryNoAuth()
    },
    isProductionEnv() {
      return EnvService.IS_PRODUCTION_CONNECTION
    },
  },
}
</script>

<style lang="scss" scoped>
.solutionsContainer {
  width: 100vw;
  .solutionsContent {
    display: flex;
    height: 100%;
    position: relative;
    width: 100%;
    margin: auto;
    align-items: center;
    &.mobileSolutionsContent {
      height: unset;
    }
  }
}
.mobileDisplayContainer {
  position: relative;
}
.solutionsTitle {
  &.mobileTitle {
    font-size: 1.5rem !important;
  }
}
.solutionThumbnailContainer {
  padding-left: 12px;
  padding-right: 12px;
}
.solutionThumbnail {
  max-width: 100%;
  height: auto;
  &.selected {
    border: 4px solid orange;
  }
  &.hovered {
    cursor: pointer;
    transform: scale(1.03);
    border: 4px solid orange;
  }
}
.thumbnailGrid {
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-areas: 'thumb1 thumb2 thumb3';
}
.backNextButtonDisplay {
  position: absolute;
  bottom: 32px;
  right: 140px;
  &.mobileBackNextButtonDisplay {
    position: fixed;
    bottom: 90px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    z-index: 10;
  }
}
</style>
